import { render, staticRenderFns } from "./index.vue?vue&type=template&id=85a494b8"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {StoryblokComponent: require('/opt/build/repo/components/Storyblok/Component.vue').default,ElementsCarousel: require('/opt/build/repo/components/Elements/Carousel.vue').default})
